import {useContext} from 'react'
import {twJoin} from 'tailwind-merge'
import {Menu, MenuButton, MenuItems} from '@headlessui/react'
import {faTrashCan} from '@fortawesome/pro-regular-svg-icons'
import {useTranslation} from 'react-i18next'

import {IconCheckmark, IconChevronDown, IconFilter} from '@sdox/icons'
import {FaIcon} from '@sdox/ui'

import {MediaLibraryContext} from './MediaLibraryContext'
import {MediaLibraryFileType} from './types'

const filterTranslationMap = {
  [MediaLibraryFileType.Image]: 'cufe:mediaLibrary.images',
  [MediaLibraryFileType.PDF]: 'cufe:mediaLibrary.pdfs',
  [MediaLibraryFileType.Video]: 'cufe:mediaLibrary.videos',
}

export const FileTypeFilter = () => {
  const {allFilters, selectedFilters, onFilterChange, resetFilters} = useContext(MediaLibraryContext)
  const {t} = useTranslation()

  if (allFilters.length <= 1) return null

  const resetDisabled = selectedFilters.length === allFilters.length
  return (
    <div className={'relative'}>
      <Menu>
        <MenuButton className={'inline-flex h-spacing-44 items-center gap-2 rounded-md bg-interactive-surface-filled-default-default px-spacing-12 py-spacing-6 text-p1 text-glyph-inversed-primary focus:outline-none data-[hover]:bg-interactive-surface-filled-default-hovered data-[open]:bg-interactive-surface-filled-default-pressed'}>
          <IconFilter />
          <span>
            {t('cufe:mediaLibrary.fileTypeFilter')} ({''}
            <span className={'inline-block w-ch'}>{selectedFilters.length}</span>{''}
            /
            <span className={'inline-block w-ch'}>{allFilters.length}</span>{''}
            )
          </span>
          <IconChevronDown />
        </MenuButton>

        <MenuItems
          className={'absolute z-10 mt-spacing-4 w-52 origin-top-right rounded-xl border border-outline-secondary bg-surface-primary px-spacing-4 py-spacing-8 text-interactive-glyph-default-primary shadow-sm transition duration-100 ease-out [--anchor-gap:var(--spacing-1)] focus:outline-none data-[closed]:scale-95 data-[closed]:opacity-0'}
        >
          {allFilters.map(filterKey => (
            <div key={filterKey}>
              <button
                className={twJoin(
                  'group flex h-spacing-44 w-full items-center justify-between gap-spacing-8 rounded-lg px-spacing-12 text-p2 hover:bg-interactive-surface-flat-default-hovered',
                  selectedFilters.includes(filterKey) && 'font-semibold',
                )}
                onClick={() => { onFilterChange(filterKey) }}
              >
                {t(filterTranslationMap[filterKey])}
                {selectedFilters.includes(filterKey) ? <IconCheckmark className={'size-spacing-24'} /> : null}
              </button>
            </div>
          ))}
          <div className={'-mx-spacing-4 my-spacing-6 h-px bg-outline-secondary'} />
          <div>
            <button
              className={twJoin(
                'group flex h-spacing-44 w-full items-center justify-between gap-2 rounded-lg px-spacing-12 text-p2',
                !resetDisabled && 'text-feedback-glyph-semantic-negative hover:bg-interactive-surface-flat-default-hovered',
                resetDisabled && 'text-glyph-default-secondary',
              )}
              onClick={resetFilters}
              disabled={resetDisabled}
            >
              {t('cufe:mediaLibrary:reset')}
              <FaIcon icon={faTrashCan} />
            </button>
          </div>
        </MenuItems>
      </Menu>
    </div>
  )
}
